/* eslint-disable arrow-body-style */
/* eslint-disable eqeqeq */
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import { Item, ItemTypesEnum } from 'src/@types/Course';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Video_DocumentItemDefaultValues,
  DocumentItemSchema,
} from './components/sectionItemsSchemas';
import TextMaxLine from 'src/components/TextMaxLine';
import { useEffect } from 'react';
import { AssetsSection } from './components/AssetsSection';
import DetailsSection from './components/DetailsSection';
import { StyledFormBox } from './components/styles';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { UploadMultiFile } from 'src/components/upload';
// ----------------------------------------------------------------------

export default function DocumentItemForm({
  onSubmit,
  currentItem,
}: {
  onSubmit(data: Item): void;
  currentItem: Item | undefined;
}) {
  const methods = useForm({
    resolver: yupResolver(DocumentItemSchema),
    defaultValues: {
      ...Video_DocumentItemDefaultValues,
      details: {
        type: ItemTypesEnum.DOCUMENT,
      },
    },
  });

  const {
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting,errors },
  } = methods;
  const values = watch();
  const updateDefaultValues = () => {
    return {
      url: currentItem?.url || '',
      assets: currentItem?.assets || [],
      title: currentItem?.title || '',
      details: currentItem?.details || { type: ItemTypesEnum.DOCUMENT },
      description: currentItem?.description || '',
      description_ar: currentItem?.description_ar || '',
      order: currentItem?.order || 0,
      title_ar: currentItem?.title_ar || '',
      points: currentItem?.points || 0,
      duration: currentItem?.duration || 0,
    } as Item;
  };

  useEffect(() => {
    if (currentItem) {
      reset(updateDefaultValues());
    }
    if (!currentItem) {
      reset({
        ...Video_DocumentItemDefaultValues,
        details: {
          type: ItemTypesEnum.DOCUMENT,
        },
      });
    }
  }, [currentItem]);


   const onUploadDocument = async (file: File) => {
     const form = new FormData();
     form.append('file', file);
     let response = undefined;
       response = await axiosInstance.post(APIS.UPLOAD.COURSE_DOCUMENT, form);
     return response.data;
   };
  return (
    <Stack height={'100%'} sx={{ overflow: 'auto' }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack direction={'column'} justifyContent={'space-between'} height={'100%'}>
          <StyledFormBox
            sx={{
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
            }}
          >
            <DetailsSection
              isDocument={true}
              isFree={values.isFreeToWatch}
              setIsFree={(val) => {
                setValue('isFreeToWatch', val);
              }}
            />{' '}
            <TextMaxLine
              sx={{
                fontSize: '18px',
                paddingBottom: '10px',
                fontWeight: '700',
              }}
            >
              Upload Document{' '}
            </TextMaxLine>
            <UploadMultiFile
              error={errors.url && (values.url == '' || !values.url) ? true : false}
              disableControl={true}
              accept={{ 'application/pdf': [] }}
              files={values.url ? [values.url] : []}
              maxFiles={1}
              label={'Select Or Drop Document'}
              onDropAccepted={async (file: any) => {
                const response = await onUploadDocument(file[0]);
                setValue('url', response.url);
              }}
            />
            <AssetsSection assets={values?.assets ?? []} setValue={setValue} />
          </StyledFormBox>
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton
              style={{ width: '200px', height: '50px' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {'Save'}
            </LoadingButton>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  );
}
